/**
 * First tab stop on every page. The site's header is sticky and its nav has
 * eight links, so a keyboard user would otherwise traverse the whole bar on
 * every route.
 */
export function SkipLink() {
  return (
    <a className="wft-skip-link" href="#wft-main">
      Skip to content
    </a>
  );
}
